import { Params, useParams } from 'react-router-dom';
import { RemusPlatform, isRemusPlatform } from '../platformConfig';

// React-side reader of the active platform: the route's `:platform` segment,
// reactive to navigation. Non-React callers use getActivePlatform() in
// platformConfig; both reflect the same browser URL and share the one validator.
function usePlatform(): RemusPlatform | null {
  const { platform } = useParams<Params>();
  return isRemusPlatform(platform) ? platform : null;
}

export default usePlatform;
